import { render } from "./NewChannel.vue?vue&type=template&id=321d41b2"
import script from "./NewChannel.vue?vue&type=script&lang=js"
export * from "./NewChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__